import {DataFetcher} from '@aboutyou/data-fetcher';
import {DeferredElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/deferred_element.types';
import {SkeletonBlock, useInView} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  CategoryHighlightSectionProductListView,
  Wrapper,
} from './CategoryHighlightSectionProductListView';
import {useGetCategoryHighlightCardProducts} from './utils/useCategoryHighlightCardProducts';

export const CategoryHighlightSectionProductListDeferred: React.FC<{
  deferred: DeferredElement;
  setCardProductIds: (productIds: number[]) => void;
}> = ({deferred, setCardProductIds}) => {
  const {ref, inView} = useInView<HTMLDivElement>({
    threshold: 0,
    rootMargin: '300px',
    triggerOnce: true,
  });

  return (
    <div ref={ref} data-testid="categoryHighlightSectionProductListDeferred">
      <DataFetcher
        request={useGetCategoryHighlightCardProducts({
          deferred,
          disabled: !inView,
        })}
        Loading={Skeleton}
        Error={null}
        View={CategoryHighlightSectionProductListView}
        viewProps={{setCardProductIds}}
      />
    </div>
  );
};

const Skeleton: React.FC = () => {
  return (
    <Wrapper>
      {Array.from({length: 3}, (_, index) => (
        <StyledSkeletonBlock key={index} disableSpaceBelow $height="100%" />
      ))}
    </Wrapper>
  );
};

const StyledSkeletonBlock = styled(SkeletonBlock)`
  aspect-ratio: 3/4;
  border-radius: unset;
`;
